// Module row metadata (W36.0, spec §2.5 R2.4 + §6.3).
//
// Split out of `ModuleList.tsx` so that file exports components only (ESLint
// `react-refresh/only-export-components`), and because the module→label and
// module→path tables are the two things a future module has to touch when it
// joins the dashboard.

import { DASHBOARD_I18N } from "@/lib/i18n/dashboard";
import type { DashboardModuleKey } from "@/lib/api/dashboard";

/** 繁體中文 labels for the 6 locked module keys (spec §2.5 R6.2). */
export const MODULE_LABEL: Record<DashboardModuleKey, string> = {
  diary: DASHBOARD_I18N.modules.diary,
  anniversary: DASHBOARD_I18N.modules.anniversary,
  calendar: DASHBOARD_I18N.modules.calendar,
  album: DASHBOARD_I18N.modules.album,
  wishlist: DASHBOARD_I18N.modules.wishlist,
  daily_message: DASHBOARD_I18N.modules.daily_message,
};

/** Where each row navigates to on desktop (§2.5 R2.4). */
export const MODULE_DETAIL_PATH: Record<DashboardModuleKey, string> = {
  diary: "/diaries",
  anniversary: "/anniversaries",
  calendar: "/calendar",
  album: "/albums",
  wishlist: "/wishes",
  daily_message: "/dashboard/messages",
};

/**
 * Runtime-safe lookups (W37.0 §4.1 (4)).
 *
 * `Record<DashboardModuleKey, …>` is exhaustive *at compile time against the
 * union declared in `lib/api/dashboard.ts` — which is hand-written, not
 * generated*. So when the backend adds a seventh key, TypeScript stays silent
 * (the union did not grow) and `MODULE_LABEL[row.key]` evaluates to
 * `undefined`: the row renders with an empty label, and `MODULE_DETAIL_PATH`
 * hands `undefined` to `<Link to>` / `navigate()`. That is a runtime failure
 * that no type checker and no unit test of this module would catch.
 *
 * Taking `string` and returning a fallback moves the check to runtime, where
 * the drift actually happens.
 */
export function moduleLabel(key: string): string {
  return MODULE_LABEL[key as DashboardModuleKey] ?? DASHBOARD_I18N.modules.loadFailed;
}

/** `null` for a key this build does not know, so the caller can drop the link. */
export function moduleDetailPath(key: string): string | null {
  return MODULE_DETAIL_PATH[key as DashboardModuleKey] ?? null;
}
